import {
  AudienceOptions,
  AudienceSettings as AudienceSettingsData,
} from "../../types/audience-compare";

import LabelWithTooltip from "../forms/LabelWithTooltip";
import { RelativeDate } from "../../types";
import { Select } from "../forms";
import css from "./AudienceSettings.module.css";
import { relativeDateOptions } from "../../utils/date/dateUtils";

type AudienceSettingsProps = AudienceSettingsData & {
  audienceOptions: AudienceOptions;
  baselineOptions: AudienceOptions;
  onChange: (data: AudienceSettingsData) => void;
};

/**
 * Renders the controls for filters like audience source, baseline, etc.
 */
function AudienceSettings({
  audience,
  audienceOptions,
  baseline,
  baselineOptions,
  dateFilter,
  onChange,
}: AudienceSettingsProps) {
  return (
    <section className={css.wrapper}>
      <div className={css.controls}>
        <div>
          <Select
            label={
              <LabelWithTooltip
                label="Audience"
                tooltip="Select one of your audiences to compare against the baseline"
              />
            }
            placeholder="Search for an Audience"
            data={audienceOptions}
            value={audience.toString()}
            onChange={(val) =>
              onChange({ baseline, audience: val ?? "", dateFilter })
            }
            searchable
          />
        </div>
        <div>
          <Select
            label={
              <LabelWithTooltip
                label="Baseline"
                tooltip="Select an audience you will be indexing against to see how you compare"
              />
            }
            placeholder="Search for a Baseline"
            data={baselineOptions}
            searchable
            value={baseline.toString()}
            onChange={(val) =>
              onChange({ baseline: val ?? "", audience, dateFilter })
            }
          />
        </div>
        <div>
          <Select
            label="Date Range"
            data={relativeDateOptions.map((x) => ({
              value: x.id,
              label: x.label,
            }))}
            value={dateFilter}
            onChange={(val) =>
              onChange({ baseline, audience, dateFilter: val as RelativeDate })
            }
          />
        </div>
      </div>
    </section>
  );
}

export default AudienceSettings;
